import { createTheme } from '@mui/material';

export function IsProduction(): boolean {
  return process.env.REACT_APP_ENV?.toString().toLowerCase().includes('production') ?? false;
}

export function GetEnv(): string {
  return process.env.REACT_APP_ENV?.toString().toLowerCase().trim() ?? 'unknown';
}

export function GetApiUrl(): string {
  const env = process.env.REACT_APP_ENV?.toString().toLowerCase().trim();
  let url;
  switch (env) {
    case 'production':
      url = getUrlFromHostname();
      url = hostnameIsLocalhost() ? process.env.REACT_APP_API_URL_PRODUCTION : url;
      break;

    case 'testing':
      url = getUrlFromHostname();
      url = hostnameIsLocalhost() ? process.env.REACT_APP_API_URL_TESTING : url;
      break;

    case 'development':
      url = process.env.REACT_APP_API_URL_DEVELOPMENT;
      break;

    default:
      throw new Error(`Environment ${env} not configured`);
  }
  return url as string;
}

export const hostnameIsLocalhost = () => window.location.hostname.includes('localhost');

export const getUrlFromHostname = () => `https://${window.location.hostname}/transportadoraapi`;

export const padTo2Digits = (num: number) => {
  return num.toString().padStart(2, '0');
};

export const formatDate = (date: Date) => {
  return [padTo2Digits(date.getDate()), padTo2Digits(date.getMonth() + 1), date.getFullYear()].join(
    '/'
  );
};

export const formCurrency = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2
});

export const formPercent = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  maximumFractionDigits: 2
});

export const theme = createTheme({
  typography: {
    fontSize: 8,
    allVariants: {
      alignContent: 'center',
      textAlign: 'center'
    },
    button: {
      textAlign: 'center',
      alignContent: 'center'
    }
  }
});
